(function () {

  function waitForCo2(callback, tries = 0) {
    if (typeof co2 !== 'undefined') {
      callback();
    } else if (tries < 30) {
      setTimeout(() => waitForCo2(callback, tries + 1), 200);
    } else {
      console.warn('[DiscountPreview] co2 not available');
    }
  }

  function fmt(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency', currency: 'EUR'
    }).format(cents / 100);
  }

  function injectBox(box, discPrice, origPrice, percent, isPDP) {
    if (box.dataset.discountInjected) return;
    box.dataset.discountInjected = '1';

    const priceList = box.querySelector('price-list');
    if (!priceList) return;

    if (priceList.querySelector('compare-at-price')) return;

    const salePriceEl = priceList.querySelector('sale-price');
    if (!salePriceEl) return;

    salePriceEl.style.textDecoration = 'line-through';
    salePriceEl.style.opacity = '0.55';

    const newPrice = document.createElement('sale-price');
    newPrice.className = isPDP
      ? 'h4 text-on-sale discount-preview-price'
      : 'text-on-sale discount-preview-price';
    newPrice.innerHTML = `<span class="sr-only">Sale price</span>${fmt(discPrice)}`;
    salePriceEl.insertAdjacentElement('afterend', newPrice);

    if (!box.querySelector('.discount-preview-badge')) {
      const badge = document.createElement('span');
      badge.className = 'vdaysale-badge-discount discount-preview-badge';
      badge.textContent = `-${percent}%`;
      newPrice.insertAdjacentElement('afterend', badge);
    }
  }

  function resetBox(box) {
    delete box.dataset.discountInjected;
    box.querySelectorAll('.discount-preview-price, .discount-preview-badge').forEach(e => e.remove());
    const sp = box.querySelector('sale-price');
    if (sp) { sp.style.textDecoration = ''; sp.style.opacity = ''; }
  }

async function processBox(box, isPDP) {
  const productId  = parseInt(box.dataset.productId, 10);
  const variantId  = parseInt(
    isPDP ? box.querySelector('price-list')?.dataset.variantId : box.dataset.variantId,
    10
  );
  const price = parseInt(box.dataset.price, 10);
  const tags  = (box.dataset.tags || '').split(',').filter(Boolean);

    let variantTags = [];
    try {
      variantTags = JSON.parse(box.dataset.variantTags || '[]');
      if (!Array.isArray(variantTags)) variantTags = [];
    } catch (e) { variantTags = []; }

  if (!productId || !variantId || !price) return;

  try {
    const result = await co2.itemDiscountFull(
      productId, 
      variantId, 
      tags, 
      price, 
      1,
      false,
      parseInt(box.dataset.compareAt, 10) > price,
      variantTags
    );  

    if (result && result.discPrice > 0 && result.discPrice < price) {
      const percent = result.discPerc || Math.round((1 - result.discPrice / price) * 100);
      injectBox(box, result.discPrice, price, percent, isPDP);
    }
  } catch(e) {
    console.warn('[DiscountPreview] itemDiscountFull error:', e.message);
  } 
}
  async function run() {
    
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        const code = cart.discount_codes[0].code || cart.discount_codes[0];
        await co2.setDiscountCode(code);
        console.log('[DiscountPreview] Code set:', code);
      } else {
        
        const currentCode = await co2.getDiscountCode();
        if (currentCode) await co2.removeDiscountCode();
        return;
      }
    } catch(e) {
      console.warn('[DiscountPreview] Cart sync error:', e);
      return;
    }

    const cardBoxes = document.querySelectorAll('.price-card-wrap-box[data-product-id]');
    for (const box of cardBoxes) {
      await processBox(box, false);
    }

    const pdpPriceList = document.querySelector('.price-card-wrap-box price-list[data-variant-id]');
    if (pdpPriceList) {
      const pdpBox = pdpPriceList.closest('.price-card-wrap-box');
      if (pdpBox) await processBox(pdpBox, true);
    }
  }

  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    let lastId = variantInput.value;

    setInterval(async function () {
      const currentId = variantInput.value;
      if (currentId && currentId !== lastId) {
        lastId = currentId;
        console.log('[DiscountPreview] Variant changed to:', currentId);

        const pdpPriceList = document.querySelector('.price-card-wrap-box price-list');
        if (pdpPriceList) pdpPriceList.dataset.variantId = currentId;

        const pdpBox = document.querySelector('.price-card-wrap-box');
        if (pdpBox) {
          resetBox(pdpBox);

          setTimeout(async () => {
            const sp = pdpBox.querySelector('sale-price');
            if (sp) {
              
              try {
                const res = await fetch(window.location.pathname + '.js');
                const product = await res.json();
                const variant = product.variants.find(v => v.id == currentId);
                if (variant) {
                  pdpBox.dataset.price = variant.price;
                  pdpBox.dataset.variantId = currentId;
                  await processBox(pdpBox, true);
                }
              } catch(e) {}
            }
          }, 300);
        }
      }
    }, 300);
  }

  waitForCo2(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  });

  //Quick Buy Modal Observer
  let modalVariantInterval = null;

  const modalObserver = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        const rerender = node.matches?.('product-rerender')
          ? node
          : node.querySelector?.('product-rerender');
        if (!rerender) continue;

        if (modalVariantInterval) {
          clearInterval(modalVariantInterval);
          modalVariantInterval = null;
        }

        setTimeout(async () => {
          const code = await co2.getDiscountCode();
          if (!code) return;

          const allBoxes = rerender.querySelectorAll('.price-card-wrap-box');
          for (const box of allBoxes) {
            resetBox(box);
            const priceList = box.querySelector('price-list[data-variant-id]');
            if (priceList) await processBox(box, true);
          }

          const modalInput = rerender.querySelector('input[name="id"]')
            || rerender.closest('.modal, x-modal')?.querySelector('input[name="id"]')
            || document.querySelector('x-modal:not([hidden]) input[name="id"]');

          if (!modalInput) return;

          let lastModalId = modalInput.value;

          modalVariantInterval = setInterval(async () => {
           
            const modalEl = rerender.closest('x-modal, .modal');
            if (modalEl && modalEl.hasAttribute('hidden')) {
              clearInterval(modalVariantInterval);
              modalVariantInterval = null;
              return;
            }

            const currentId = modalInput.value;
            if (currentId && currentId !== lastModalId) {
              lastModalId = currentId;

              setTimeout(async () => {
                try {
                  
                  const quickBuyModal = rerender.closest('quick-buy-modal');
                  const handleRaw = quickBuyModal?.getAttribute('handle') || '';
                  const handle = handleRaw.split('?')[0]; 

                  const productRes = await fetch('/products/' + handle + '.js');
                  const product = await productRes.json();
                  const variant = product.variants.find(v => v.id == currentId);

                  if (variant) {
                    const allModalBoxes = rerender.querySelectorAll('.price-card-wrap-box');
                    for (const box of allModalBoxes) {
                      resetBox(box);
                      box.dataset.variantId = currentId;
                      box.dataset.price = variant.price;
                      const priceList = box.querySelector('price-list');
                      if (priceList) priceList.dataset.variantId = currentId;
                      await processBox(box, true);
                    }
                  }
                } catch(e) {
                  console.warn('[DiscountPreview] Modal variant error:', e);
                }
              }, 300);
            }
          }, 300);

        }, 400);
      }
    } 
  }); 
  modalObserver.observe(document.body, { childList: true, subtree: true }); 
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (evt) {
  document.addEventListener(evt, async function () {
    const boxes = document.querySelectorAll('.price-card-wrap-box'); 
    boxes.forEach(resetBox); 
    try {
      const cart = await (await fetch('/cart.js')).json();
       if (cart.discount_codes && cart.discount_codes.length > 0) {
        setTimeout(run, 200);
      } else {
        const currentCode = await co2.getDiscountCode();
        if (currentCode) await co2.removeDiscountCode();
      }
    } catch (e) {}
  }, true);
});
})();